import React, { Component } from 'react';
import PropTypes from 'prop-types'; // ES6
import { Collapse, Card } from 'antd';

const Panel = Collapse.Panel;

class ObservacioDetallSeccioVariables extends Component {

    renderValors(valors, variable) {
        const { codiAtribut, unitat } = variable;

        let valorsAMostrar = valors.map((valor) => {
            return valor;
        });

        return this.esValorPrecipitacioTotal24hInapreciable(valors, codiAtribut) ? 'ip' : valorsAMostrar + ' ' + unitat;
    }

    esValorPrecipitacioTotal24hInapreciable(valorsAMostrar, codiAtribut) {
        return valorsAMostrar.length === 1 && valorsAMostrar[0] === 0.0 && codiAtribut === '-3';
    }

    renderMoment(variable) {
        return variable.moments.map((moment, index) => {
            return (
                <div key={moment.valors[0] + '-' + index} className='salt-de-linia'>
                    <span>{moment.nom}:</span>{this.renderValors(moment.valors, variable)}
                </div>
            );
        });
    }

    renderVariable(grup) {
        return grup.variables.map((variable, index) => {
            return (
                <div key={variable.nom + '-' + index} className='observacio-detall-variable'>
                    <span className='observacio-detall-variable-nom'>{variable.nom}:</span>
                    {this.renderMoment(variable)}
                </div>
            );
        });
    }

    renderGrup(variables) {
        return variables.map((grup, index) => {
            return (
                <Panel header={grup.grup} key={grup.grup + '-' + index}>
                    {this.renderVariable(grup)}
                </Panel>
            );
        });
    }

    render() {
        const variables = this.props.variables;

        return (
            <Card id='variables' title='Variables' extra='Totes les hores es mostren en UTC' className='scrollable'>
                <Collapse defaultActiveKey={['0']}>
                    {this.renderGrup(variables)}
                </Collapse>
            </Card>
        );
    }
}

ObservacioDetallSeccioVariables.propTypes = {
    variables: PropTypes.array.isRequired
};

export default ObservacioDetallSeccioVariables;



// WEBPACK FOOTER //
// ./src/components/observacio/observacioDetallSeccioVariables.js